"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 20c.006.51-.491 1.008-1 1H4c-.503.008-1-.49-1-1V8.01c0-.642.45-1.065 1-1.325l7.042-3.476c.55-.26 1.372-.297 2 0l6.964 3.476c.55.26 1.007.608.994 1.325V20zm-11-6.009a1 1 0 00-1 1V21h6V14.99a1 1 0 00-1-1h-4z" }), "Home");
//# sourceMappingURL=Home.js.map